export default {
  INDEX: "/",
  PROCESSING: "/processing/:hash?",
  RESULT: "/result",
  ERROR: "/error",
  PHOTOCHOOSER: "/photochooser",
};
